// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"129":"06043a84","913":"2a61c7ab"}[chunkId] + ".css";
};